import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window to the top whenever the route's pathname changes.
// Skips when only the hash changes (e.g. in-page anchor links) or when
// router state explicitly opts out via { state: { keepScroll: true } }.
export default function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state?.keepScroll) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, state]);

  return null;
}
